import React from "react";
import { motion } from "framer-motion";
import { ClockIcon, CookieIcon, BanIcon } from "lucide-react";
import { Reveal } from "../ui/Reveal";
import { desserts, lifestyle } from "../../data/images";
import { EASE_OUT } from "../../utils/motion";
export function StorySection() {
  return <section className="bg-white py-20 lg:py-28" data-id="element-428" data-mp="gughmcp0sxux">
      <div className="mx-auto grid max-w-6xl items-center gap-14 px-5 lg:grid-cols-2" data-id="element-429" data-mp="gv8f5t26h5nu">
        <Reveal x={-24} y={0} className="relative" data-id="element-430" data-mp="kuzbecah4dzr">
          <div className="overflow-hidden rounded-[2rem] shadow-[0_30px_60px_-25px_rgba(59,34,25,0.5)] ring-8 ring-blush-light" data-id="element-431" data-mp="pubymy59bn2v">
            <img src={lifestyle.kitchen} alt="Mujer cansada frente al refrigerador a las 4 de la tarde" className="aspect-[4/3] w-full object-cover" data-id="element-432" data-mp="umd8kdeyd1pq" />
          </div>
          <motion.div initial={{
          opacity: 0,
          scale: 0.96,
          y: 10
        }} whileInView={{
          opacity: 1,
          scale: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: 0.2,
          ease: EASE_OUT
        }} className="absolute -bottom-6 right-4 flex items-center gap-3 rounded-2xl bg-cocoa px-5 py-3 text-cream shadow-xl sm:-right-4" data-id="element-433" data-mp="14jrn27hbfgfe">
            <ClockIcon className="h-8 w-8 text-gold-light" data-id="element-434" data-mp="1lrps9vve0ucf" />
            <div data-id="element-435" data-mp="1ls7wpfs7eevf">
              <p className="text-xs uppercase tracking-wider text-cream/70" data-id="element-436" data-mp="1ltsrn6ifjztt">Un martes cualquiera</p>
              <p className="font-display text-3xl font-bold leading-none" data-id="element-437" data-mp="1gv96377r0q1z">4:00 PM</p>
            </div>
          </motion.div>
        </Reveal>

        <div data-id="element-438" data-mp="29hafws2hkfs1">
          <Reveal data-id="element-439" data-mp="29iv665hrpck3">
            <h2 className="font-display text-3xl font-bold leading-tight text-cocoa sm:text-4xl lg:text-5xl" data-id="element-440" data-mp="29ibz5jtno8ku">
              La Mañana Que Tu Digestión Cambió Para Siempre
            </h2>
          </Reveal>
          <Reveal delay={0.05} className="mt-6 space-y-5 text-lg leading-relaxed text-cocoa-light" data-id="element-441" data-mp="1zpo6905sqore">
            <p data-id="element-442" data-mp="2x97q6eqaezr1">
              Era un martes cualquiera. Eran las 4 de la tarde, esa hora mágica donde tu cuerpo pide algo dulce como quien pide aire.
            </p>
            <p data-id="element-443" data-mp="qk71re0m4w2k">
              Yo estaba en la cocina, mirando al espejo del refrigerador: mi reflejo me devolvía una mujer{" "}
              <b className="text-cocoa" data-id="element-444" data-mp="vk1snhke1lnm">cansada, hinchada, con ojeras que parecían de luto.</b>
            </p>
          </Reveal>
        </div>
      </div>

      <div className="mx-auto mt-24 max-w-5xl px-5" data-id="element-445" data-mp="lrdw8nxbljpf">
        <Reveal data-id="element-446" data-mp="lpt2h0ity4sm">
          <p className="text-center text-lg text-cocoa-light" data-id="element-447" data-mp="7sec9tkr5szl">
            Mis hijos habían llegado del colegio. Yo tenía <b className="text-cocoa" data-id="element-448" data-mp="buhlscnv2ni8">dos opciones</b>:
          </p>
        </Reveal>
        <div className="relative mt-8 grid gap-5 md:grid-cols-2" data-id="element-449" data-mp="3tzkxig8c1xrm">
          <Reveal className="h-full" data-id="element-450" data-mp="3u1fg3nw4tdsj">
            <Option icon={<CookieIcon className="h-6 w-6" data-id="element-452" data-mp="2ucr933rnjlh" />} title="Una galleta industrial" body="Sabía que les iba a dejar hiperactivos hasta las 9 de la noche." tag="Azúcar refinada + harinas" data-id="element-451" data-mp="2t1lixqrg1rq" />
          </Reveal>
          <Reveal delay={0.08} className="h-full" data-id="element-453" data-mp="1x4ygh0oevprj">
            <Option icon={<BanIcon className="h-6 w-6" data-id="element-455" data-mp="3hn91kytgvpvv" />} title="Negarles el dulce por completo" body="Lo que resultaba en un drama de 20 minutos." tag="Lágrimas + culpa" data-id="element-454" data-mp="3hq4z4m1ekcjs" />
          </Reveal>
          <span className="absolute left-1/2 top-1/2 hidden h-12 w-12 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-cocoa font-display text-lg font-bold italic text-cream shadow-lg md:flex" data-id="element-456" data-mp="3moq1os44n8be">
            o
          </span>
        </div>

        <Reveal className="mt-20 text-center" data-id="element-457" data-mp="3viungx4eltk2">
          <p className="font-display text-4xl font-bold italic text-berry sm:text-5xl" data-id="element-458" data-mp="e8wksc5vvutt">Pero ese martes fue diferente.</p>
        </Reveal>
      </div>

      <div className="mx-auto mt-16 grid max-w-6xl items-center gap-14 px-5 lg:grid-cols-[1.1fr_1fr]" data-id="element-459" data-mp="97gyyhvvtkad">
        <Reveal className="space-y-5 text-lg leading-relaxed text-cocoa-light" data-id="element-460" data-mp="2g2403llhycfp">
          <p data-id="element-461" data-mp="2b2hnnedht07y">
            Ese martes descubrí algo que los reposteros profesionales llevan años ocultando:{" "}
            <b className="text-cocoa" data-id="element-462" data-mp="1262mn9yw6guq">
              que un postre verdaderamente gourmet, sin azúcar refinada, sin gluten y sin lactosa, puede saber MEJOR que uno tradicional
            </b>{" "}
            — si sabes exactamente qué hacer.
          </p>
          <p data-id="element-463" data-mp="1g40vy0ycvn3d">
            Y no estoy hablando de sacrificar sabor. Estoy hablando de postres que harían que hasta un crítico gastronómico levantara las cejas y
            preguntara:
          </p>
        </Reveal>
        <Reveal x={24} y={0} className="relative" data-id="element-464" data-mp="odd0n5jd5bxm">
          <img src={desserts.chocolateCake} alt="Torta de chocolate sin azúcar, sin gluten y sin lactosa" className="aspect-[4/5] w-full rounded-[2rem] object-cover shadow-[0_30px_60px_-25px_rgba(59,34,25,0.5)] ring-8 ring-white" data-id="element-465" data-mp="se6o5xsw8opz" />
          <motion.blockquote initial={{
          opacity: 0,
          scale: 0.96,
          y: 12
        }} whileInView={{
          opacity: 1,
          scale: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: 0.25,
          ease: EASE_OUT
        }} className="absolute -left-4 top-8 max-w-[240px] rounded-2xl rounded-bl-none bg-white p-4 font-display text-xl font-semibold italic text-cocoa shadow-xl sm:-left-10" data-id="element-466" data-mp="kwfun88r5um">
            "¿En serio esto no tiene azúcar?"
          </motion.blockquote>
        </Reveal>
      </div>
    </section>;
}
function Option({
  icon,
  title,
  body,
  tag
}: {
  icon: React.ReactNode;
  title: string;
  body: string;
  tag: string;
}) {
  return <div className="flex h-full flex-col rounded-3xl bg-blush-light p-7" data-id="element-467" data-mp="35jjxnv8wvj6u">
      <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white text-cocoa shadow-sm" data-id="element-468" data-mp="30mlajwno0ci5">{icon}</span>
      <h3 className="mt-5 font-display text-2xl font-bold text-cocoa" data-id="element-469" data-mp="2wm194gw26mq7">{title}</h3>
      <p className="mt-2 text-cocoa-light" data-id="element-470" data-mp="2rkkc4wgp3kew">{body}</p>
      <span className="mt-auto w-fit pt-5 text-sm font-semibold text-berry" data-id="element-471" data-mp="2mmahqo2sonuc">{tag}</span>
    </div>;
}